(() => {
  const minimumFontSize = 11;
  const maximumFontSizes = new WeakMap();
  const lastWidths = new WeakMap();
  const observedTitles = new WeakSet();

  const getRenderedTextWidth = (title) => {
    const range = document.createRange();
    range.selectNodeContents(title);
    return range.getBoundingClientRect().width;
  };

  const fitTitle = (title) => {
    if (!(title instanceof HTMLElement) || title.clientWidth === 0) return;

    if (!maximumFontSizes.has(title)) {
      maximumFontSizes.set(title, Number.parseFloat(getComputedStyle(title).fontSize));
    }

    const maximumFontSize = maximumFontSizes.get(title);
    if (!Number.isFinite(maximumFontSize)) return;

    title.style.fontSize = `${maximumFontSize}px`;
    if (getRenderedTextWidth(title) <= title.clientWidth) return;

    let lowerBound = minimumFontSize;
    let upperBound = maximumFontSize;

    for (let index = 0; index < 8; index += 1) {
      const candidate = (lowerBound + upperBound) / 2;
      title.style.fontSize = `${candidate}px`;

      if (getRenderedTextWidth(title) <= title.clientWidth) {
        lowerBound = candidate;
      } else {
        upperBound = candidate;
      }
    }

    title.style.fontSize = `${lowerBound}px`;
  };

  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const width = entry.contentRect.width;
      if (lastWidths.get(entry.target) === width) continue;

      lastWidths.set(entry.target, width);
      fitTitle(entry.target);
    }
  });

  const initializeTitles = (root = document) => {
    for (const title of root.querySelectorAll('.product-details h1')) {
      fitTitle(title);

      if (!observedTitles.has(title)) {
        observedTitles.add(title);
        lastWidths.set(title, title.getBoundingClientRect().width);
        resizeObserver.observe(title);
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeTitles(), { once: true });
  } else {
    initializeTitles();
  }

  document.addEventListener('shopify:section:load', (event) => initializeTitles(event.target));
})();
